<app-table
  modelName="Edições"
  [cols]="columns"
  [service]="subscriberService"
  pageFunctionName="findEditionsCustomizationsTable"
  sortField="editionDate"
  [sortOrder]="1"
/>
